import styled from 'styled-components';
import { gray1 } from '@styles/styled/variables';
import { MoreDropDown } from '@components/common';

export const StyledToolbox = styled.div`
  margin: 20px 28px 0;
  color: #253852;
  font-size: 24px;
`;

export const StyleTitle = styled.span`
  color: ${gray1};
  margin-right: 16px;
`;

export const StyledMoreDropDown = styled(MoreDropDown)`
  && {
    position: absolute;
    top: 15px;
    right: 4px;
  }
`;
